import setErrorMessage from './set-error-message';

export default {
  setErrorMessage,
};
